import React from 'react';
import FeatureHeading from './FeatureHeading';
import FeatureTable from './FeatureTable';
import './features.scss';

const Features = () => {
  return (
    <div id="pricing">
      <FeatureHeading />
      <FeatureTable />
    </div>
  );
};

export default Features;
